var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranslation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00022 0.928734C4.54279 0.928734 0.928955 4.54256 0.928955 9C0.928955 13.4574 4.54279 17.0713 9.00022 17.0713C13.4577 17.0713 17.0715 13.4574 17.0715 9C17.0715 4.54256 13.4577 0.928734 9.00022 0.928734Z",
    stroke: "#1890FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.928734C7.28418 0.928734 5.6709 4.54256 5.6709 9C5.6709 13.4574 7.28418 17.0713 9 17.0713C10.7158 17.0713 12.3291 13.4574 12.3291 9C12.3291 4.54256 10.7158 0.928734 9 0.928734Z",
    stroke: "#1890FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0715 9H0.928955",
    stroke: "#1890FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslation);
export default __webpack_public_path__ + "static/media/translation.fdd5acd4ead5a9152de75caf3dd1b180.svg";
export { ForwardRef as ReactComponent };